// Text that ends a thought: sentence punctuation or a line break.
const ENDS_THOUGHT = /(?:[.!?:]|\n)\s*$/u
// Text that can only carry on a sentence: a lowercase or digit start, closing
// or joining punctuation, a path or URL tail, or a leading space.
const CONTINUES_SENTENCE = /^(?:[ \t]|[\p{Ll}\p{N},;:)\]}'’/\-–—]|\.\S)/u

/**
 * Whether `next` carries on `previous` mid-sentence ("Good Morning" +
 * ", Vaun!") rather than starting a new thought.
 */
export function continuesText(previous: string, next: string): boolean {
  return !!previous.trim() && !ENDS_THOUGHT.test(previous) && CONTINUES_SENTENCE.test(next)
}
